export default __webpack_public_path__ + "static/media/restart_video.5ad46e18.svg";